import { useQuery } from "@tanstack/react-query";

import { signedConsentDocumentsQueryOptionsFactory } from "~/providers/factories/signedConsentDocumentsQueryOptionsFactory";
import {
  ListSignedConsentDocumentsResponse,
  SignedConsentDocumentsRequest,
} from "~/providers/types/consentDocuments";

export const useSignedConsentDocuments = ({
  organizationId,
  patientId,
}: SignedConsentDocumentsRequest) => {
  return useQuery<ListSignedConsentDocumentsResponse[]>(
    signedConsentDocumentsQueryOptionsFactory.list({
      organizationId,
      patientId,
    }),
  );
};
